export enum EnumHorarioFuncionamentoUtil {
  HORARIO_COMERCIAL = 1,
  VIGILANCIA_24H = 2,
  MANHA = 3,
  TARDE = 4,
  NOITE = 5,
  OUTROS = 6,
  MADRUGADA = 7,
  SEG_A_SEX = 8,
  SEG_A_SEX_08_00_AS_18_00 = 9,
  OITO_AS_DOZE_TREZE_AS_DEZOITO = 10,
  OITO_AS_DOZE_CATORZE_AS_DEZOITO = 11,
  SEG_A_SEX_09_00_AS_17_00 = 12,
  NOVE_AS_DOZE_TREZE_AS_DEZESSETE = 13,
  SEG_A_SAB_09_00_AS_18_00 = 14,
  NOVE_AS_DOZE_TREZE_AS_DEZOITO = 15,
  SEG_A_SEX_APOS_AS_18_00 = 16,
}

export enum EnumTipoTecnologia {
  WEB = 3,
  TEF = 7,
}